import NavBar from '../components/NavBar/navBar';
import Footer from '../components/Footer/footer';
import AboutContent from '../components/PageContent/AboutContent/aboutContent';

function About() {
  return (
    <div className="app">
      <NavBar pageActive={2}/>
      <div className="page-content">
        <AboutContent />
      </div>
      <Footer />
    </div>
  );
}

export default About;
